import React, { use, useEffect, useMemo, useState } from "react";
import axios from 'axios';
import { Backdrop, CircularProgress } from "@mui/material";

import {

  Box,
  TextField,
  Button,
  Snackbar,
  Alert,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Chip,
  FormHelperText,
  Container,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { API_BASE_URL } from "../../constant/constant";
import { decrypt } from "../../components/cryptoUtil";

const fieldSx = { width: "100%" };

export default function NewUserCreation() {
  // ---- dropdown data ----
  const [roles, setRoles] = useState([]);
  const [menus, setMenus] = useState([]);
  const [softwares, setSoftwares] = useState([]);
  const [softUser, setSoftUser] = useState([]);

  const [selectedSoftware, setSelectedSoftware] = useState();
  const [selectedSoftwareuser, setSelectedSoftwareuser] = useState(null);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [loadingSoftwares, setLoadingSoftwares] = useState(false);
  const [loadingSoftwaresUser, setLoadingSoftwaresUsers] = useState(false);
  const [loadingMenus, setLoadingMenus] = useState(false);
  const UserDetails = (JSON.parse(decrypt(localStorage.getItem('tokenData'))));



 const [allowedMenus, setAllowedMenus] = useState([]);
const [availableMenus, setAvailableMenus] = useState([]);  
 
 
 
 
 // ---- snackbar ----
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // ---- form ----
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      userId: "",
      password: "",
      email: "",
      userrole: "",
      userfullname: "",
      mobile: "",
      softgroup: "",
      softsubgroup: "",
      //softwares :[],

      softwareuser: [],
      menuallowed: [], // array of menu ids

      // menuallowed: "", 

    },
    mode: "onBlur",
  });

  // ---- fetch Software List ----
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        setLoadingSoftwares(true);
        const res = await axios.get(`${API_BASE_URL}/api/softwareslist`,

          {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${token}`, // optional, set default headers
            },
          }


        );
        const data = res.data || [];  // Axios gives parsed data here
        if (!ignore) setSoftwares(Array.isArray(data) ? data : []);
        if (data.length > 0) setSelectedSoftware(data[0]);
        //  console.log("Sofwtare List:", data);

        
        //setAvailableMenus
      } catch (err) {
        console.error("Error fetching Software List", err);
        // fallback demo data if needed
        // if (!ignore) setRoles([{ id: 1, roledetails: "User" }]);
      } finally {
        if (!ignore) setLoadingSoftwares(false);
      }
    })();
    return () => {
      ignore = true;
    };
  }, []); // add dependency so it refetches if softgroup changes


  // effect to fetch software users
  useEffect(() => {
    if (!selectedSoftware) return;

    (async () => {
      try {
        setLoadingSoftwaresUsers(true);
        // console.log("Fetching Software Users for softgroup:", selectedSoftware.softgroupcode);

        const res = await axios.get(
          `${API_BASE_URL}/api/softwareuser/${selectedSoftware.softgroupcode}`,

          {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${token}`, // optional, set default headers
            },
          }
        );

        setSoftUser(Array.isArray(res.data) ? res.data : []);
        //console.log("Software User response:", res.data);
      } catch (err) {
        console.error("Error fetching Software Users:", err);
      } finally {
        setLoadingSoftwaresUsers(false);
      }
    })();
  }, [selectedSoftware]);


  // Roles effect
  useEffect(() => {
    if (!selectedSoftware) return;   // ✅ skip if null

    let ignore = false;
    (async () => {
      try {
        setLoadingRoles(true);

        const listusersoftware =
          UserDetails.userId === "admin"
            ? selectedSoftware.softgroupcode
            : UserDetails.softgroup || "";

        const res = await axios.get(`${API_BASE_URL}/api/roles/${listusersoftware}`,

          {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${token}`, // optional, set default headers
            },
          });
        // console.log("Selected Software:", selectedSoftware.softgroupcode);

        const data = res.data || [];
        if (!ignore) setRoles(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching roles:", err);
      } finally {
        if (!ignore) setLoadingRoles(false);
      }
    })();

    return () => { ignore = true };
  }, [selectedSoftware]);   // ✅ depend on object, not .softgroupcode

  

  useEffect(() => {
    if (!selectedSoftware) return;

    let ignore = false;
    (async () => {
      try {
        setLoadingMenus(true);

        const listusersoftware =
          UserDetails.userId === "admin"
            ? selectedSoftware.softgroupcode
            : UserDetails.softgroup || "";

        const res = await axios.get(`${API_BASE_URL}/api/menus/${listusersoftware}`,

          {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${token}`, // optional, set default headers
            },
          });
        const data = res.data || [];
        if (!ignore) setMenus(Array.isArray(data) ? data : []);
        if (!ignore) setAvailableMenus(Array.isArray(data) ? data : []);
        setAllowedMenus([]);
      } catch (err) {
        console.error("Error fetching menus:", err);
      } finally {
        if (!ignore) setLoadingMenus(false);
      }
    })();

    return () => { ignore = true };
  }, [selectedSoftware]);

  const token = localStorage.getItem("token");

  const menuMap = useMemo(() => {
    const m = new Map();
    menus.forEach((item) => m.set(item.id, item.softgroup));
    return m;
  }, [menus]);




  const onSubmit = async (payload) => {
    //  console.log(UserDetails);
    try {

      const fixedPayload = {
        ...payload,
        //softgroup: payload.softgroup && payload.softgroup.trim() !== "" ? payload.softgroup : UserDetails.softgroup,

        softgroup: UserDetails.userId === "admin" ? payload.software : UserDetails.softgroup,
        softsubgroup: UserDetails.userId === "admin" ? payload.softwareuser : UserDetails.softsubgroup,
        createduser: UserDetails.userId === "admin" ? "admin" : UserDetails.userId,
        userId: (UserDetails.userId === "admin" ? payload.softwareuser : UserDetails.softsubgroup) + "_" + payload.userId,
      };


      const res = await axios.post(`${API_BASE_URL}/api/userscreation`, fixedPayload
        , {
          headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`, // optional, set default headers
          },
        }
      );

      setSnackbar({
        open: true,
        message: "User created successfully!",
        severity: "success",
      });
      reset();
    } catch (e) {
      setSnackbar({
        open: true,
        message: "Failed to create user",
        severity: "error",
      });
    }

  };

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Box
        sx={{
          p: 3,
          borderRadius: 3,
          boxShadow: 4,
          bgcolor: "#fff",
        }}
      >

        <Box
          sx={{
            bgcolor: "primary.main",   // MUI theme primary color
            color: "white",
            py: 2,
            textAlign: "center",
            borderRadius: "8px 8px 0 0", // rounded only top corners
          }}
        >
          <Typography variant="h5" fontWeight="bold">
            👨🏻‍💻 Create New User
          </Typography>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          {/* Two-per-row layout using CSS grid */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 2,
              mt: 2,
            }}
          >

            {UserDetails.userId === "admin" && (
              <>
                {/* Software Dropdown */}
                <FormControl sx={fieldSx} size="small" error={!!errors.software}>
                  <InputLabel>Software</InputLabel>
                  <Controller
                    name="software"
                    control={control}
                    rules={{ required: "Select a Software" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        input={<OutlinedInput label="User Software" />}
                        disabled={loadingSoftwares}
                        onChange={(e) => {
                          field.onChange(e);  // update react-hook-form value
                          const selected = softwares.find(
                            (s) => s.softgroupcode === e.target.value
                          );
                          setSelectedSoftware(selected || null);   // ✅ update state
                          // console.log("Selected Software Group:", selected);
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: { maxHeight: 48 * 3 + 8 },
                          },
                        }}
                      >
                        {softwares.length > 0 ? (
                          softwares.map((r) => (
                            <MenuItem key={r.id} value={r.softgroupcode}>
                              {r.softwarename}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No Software available</MenuItem>
                        )}
                      </Select>
                    )}
                  />
                  <FormHelperText>{errors.software?.message}</FormHelperText>
                </FormControl>

                {/* Software User Dropdown */}
                <FormControl sx={fieldSx} size="small" error={!!errors.softwareuser}>
                  <InputLabel>Software User</InputLabel>
                  <Controller
                    name="softwareuser"
                    control={control}
                    rules={{ required: "Select a Software User Group" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        input={<OutlinedInput label="Software User Group" />}
                        disabled={loadingSoftwaresUser}
                        MenuProps={{
                          PaperProps: {
                            style: { maxHeight: 48 * 3 + 8 },
                          },
                        }}
                      >
                        {softUser.length > 0 ? (
                          softUser.map((u) => (
                            <MenuItem key={u.id} value={u.softsubgroupcode}>
                              {u.sofwaredetailsname}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No Software User Group</MenuItem>
                        )}
                      </Select>
                    )}
                  />
                  <FormHelperText>{errors.softwareuser?.message}</FormHelperText>
                </FormControl>
              </>
            )}


            {/* Row 1 */}
            <TextField
              label="User ID"
              sx={fieldSx}
              {...register("userId", { required: "User ID is required" })}
              error={!!errors.userId}
              helperText={errors.userId?.message}
              size="small"
            />
            {/* <TextField
              label="Password"
              type="password"
              size="small"
              sx={fieldSx}
              {...register("password", {
                required: "Password is required",
                minLength: { value: 6, message: "Minimum 6 characters" },
              })}
              error={!!errors.password}
              helperText={errors.password?.message}
            /> */}

            {/* Row 2 */}
            <TextField
              label="Email"
              type="email"
              size="small"
              sx={fieldSx}
              {...register("email", {
                required: "Email is required",
                pattern: { value: /^\S+@\S+$/i, message: "Invalid email" },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
            />
            <TextField
              label="Full Name"
              sx={fieldSx}
              size="small"
              {...register("userfullname", { required: "Full name is required" })}
              error={!!errors.userfullname}
              helperText={errors.userfullname?.message}
            />

            {/* Row 3 */}
            <TextField
              label="Mobile"
              size="small"
              sx={fieldSx}
              {...register("mobile", {
                required: "Mobile number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Must be 10 digits",
                },
              })}
              error={!!errors.mobile}
              helperText={errors.mobile?.message}
              inputProps={{
                maxLength: 10, // restrict to 10 characters
                inputMode: "numeric", // mobile keyboard shows numbers
                pattern: "[0-9]*", // hint for numeric input
              }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // remove non-digits
              }}
            />

            <FormControl sx={fieldSx} size="small" error={!!errors.userrole}>
              <InputLabel>User Role</InputLabel>
              <Controller
                name="userrole"
                control={control}
                rules={{ required: "Select a role" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    input={<OutlinedInput label="User Role" />}
                    disabled={loadingRoles}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 3 + 8, // 3 items visible with padding
                        },
                      },
                    }}
                  >
                    {roles.length > 0 ? (
                      roles.map((r) => (
                        <MenuItem key={r.id} value={r.rolecode}>
                          {r.roledetails}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No roles available</MenuItem>
                    )}
                  </Select>
                )}
              />
              <FormHelperText>{errors.userrole?.message}</FormHelperText>
            </FormControl>




            {/* Row 5 (full width) */}
        

         </Box>



<div style={{ marginTop: "32px" }}>
  <Controller
    name="menuallowed"
    control={control}
    rules={{
      validate: (v) => (v?.length ? true : "Select at least one menu"),
    }}
    render={({ field }) => {
      const moveToAllowed = (menu) => {
        const newAllowed = [...allowedMenus, menu];
        setAllowedMenus(newAllowed);
        setAvailableMenus((prev) => prev.filter((m) => m.id !== menu.id));
        field.onChange(newAllowed.map((m) => m.id));
      };

      const moveToAvailable = (menu) => {
        const newAllowed = allowedMenus.filter((m) => m.id !== menu.id);
        setAllowedMenus(newAllowed);
        setAvailableMenus((prev) => [...prev, menu]);
        field.onChange(newAllowed.map((m) => m.id));
      };

      return (
       <div>
          <Box display="flex" gap={3} width="100%">
            {/* Available Menus */}
            <Box flex={1}>
              <Typography variant="subtitle1" color="red" fontWeight="bold" mb={1}>
                📢 Available Menus
              </Typography>
              <Box
                border={1}
                borderRadius={2}
                p={1}
                height={200}
                sx={{ overflowY: "auto", bgcolor: "#fafafa" }}
              >
                {availableMenus.map((menu) => (
                  <Typography
                    key={`available-${menu.id}`}
                    onClick={() => moveToAllowed(menu)}
                    sx={{ cursor: "pointer", "&:hover": { color: "blue" } }}
                  >
                    {menu.menuname}
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* Allowed Menus */}
            <Box flex={1}>
              <Typography variant="subtitle1"  color="green" fontWeight="bold" mb={1}>
                ☑️ Allowed Menus
              </Typography>
              <Box
                border={1}
                borderRadius={2}
                p={1}
                height={200}
                sx={{ overflowY: "auto", bgcolor: "#f9f9f9" }}
              >
                {allowedMenus.map((menu) => (
                  <Typography
                    key={`allowed-${menu.id}`}
                    onClick={() => moveToAvailable(menu)}
                    sx={{ cursor: "pointer", "&:hover": { color: "red" } }}
                  >
                    {menu.menuname}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Box>

          {/* Error message */}
          {/* {errors.menuallowed && (
            <Typography variant="caption" color="error">
              {errors.menuallowed.message}
            </Typography>
          )} */}
        </div>
      );
    }}
  />
</div>






          {/* Buttons */}
          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Button
              type="button"
              variant="outlined"
              onClick={() => reset()}
              disabled={isSubmitting}
            >
              Reset
            </Button>
            <Button type="submit" variant="contained" disabled={isSubmitting}>
              {isSubmitting ? "Saving..." : "Create User"}
            </Button>
          </Box>
        </form>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      >
        <Alert
          variant="filled"
          severity={snackbar.severity}
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Backdrop
        open={isSubmitting}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

    </Container>



  );
}
